import { forwardRef } from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import { CSwitch } from 'components/atoms';
import { ICSwitchWithLabel } from 'types/molecules';
import customTwMerge from 'utils/twMerge';

const CSwitchWithLabel = forwardRef<HTMLLabelElement, ICSwitchWithLabel>(
  ({ labelClassName, ...rest }, ref) => {
    return (
      <FormControlLabel
        {...rest}
        ref={ref}
        control={<CSwitch />}
        classes={{ label: customTwMerge('text-inherit text-body14', labelClassName ?? '') }}
      />
    );
  }
);

export default CSwitchWithLabel;

